import { useCurrenciesContext } from '@talos/kyoko';
import { useMemo } from 'react';

// Waiting for service to provide USDPegged Currencies filter (PORT-17215)
export const useUsdPeggedCurrencies = () => {
  const { currenciesList } = useCurrenciesContext();

  return useMemo(() => {
    const expectedCurrencies = new Set(['USD', 'USDC', 'USDT']);
    return currenciesList.filter(currency => expectedCurrencies.has(currency.Symbol));
  }, [currenciesList]);
};
